import { useEffect } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { BASE_ROUTES, QUIZ_ROUTES } from 'core/common/constants';
import { joinUrls } from 'core/common/utils/joinUrls';

export const NotFoundContainerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const NotFoundPage = () => {
  const router = useRouter();

  useEffect(() => {
    router.replace(joinUrls(BASE_ROUTES.APP_SUBSCRIPTION_4_7D_TRIAL_PER_DAY, QUIZ_ROUTES.GENDER));
  }, [router]);

  return <NotFoundContainerStyled>Loading....</NotFoundContainerStyled>;
};

export default NotFoundPage;
